interface LogoProps {
  size?: 'sm' | 'md' | 'lg'
  showText?: boolean
}

export function Logo({ size = 'md', showText = true }: LogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
  }

  const textClasses = {
    sm: 'text-base',
    md: 'text-lg',
    lg: 'text-2xl',
  }

  return (
    <div className="flex items-center gap-2">
      <svg
        className={sizeClasses[size]}
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Background circle */}
        <circle cx="50" cy="50" r="48" fill="#16a34a" />

        {/* Seedling/sprout */}
        <path
          d="M50 75 L50 45"
          stroke="#fff"
          strokeWidth="6"
          strokeLinecap="round"
        />

        {/* Left leaf */}
        <path d="M50 55 Q35 45 30 30 Q45 35 50 55" fill="#fff" />

        {/* Right leaf */}
        <path d="M50 45 Q65 35 70 20 Q55 25 50 45" fill="#fff" />

        {/* Sun rays */}
        <circle cx="70" cy="25" r="8" fill="#fbbf24" />
        <g stroke="#fbbf24" strokeWidth="2" strokeLinecap="round">
          <line x1="70" y1="12" x2="70" y2="8" />
          <line x1="70" y1="42" x2="70" y2="38" />
          <line x1="57" y1="25" x2="53" y2="25" />
          <line x1="83" y1="25" x2="87" y2="25" />
          <line x1="61" y1="16" x2="58" y2="13" />
          <line x1="79" y1="34" x2="82" y2="37" />
          <line x1="61" y1="34" x2="58" y2="37" />
          <line x1="79" y1="16" x2="82" y2="13" />
        </g>
      </svg>
      {showText && (
        <span className={`font-semibold text-primary-600 ${textClasses[size]}`}>
          Brightseed
        </span>
      )}
    </div>
  )
}
